import { h, Component } from 'preact';
import Search from 'components/bolt/icons/search';
import HeaderExpanded from 'components/bolt/header/headerExpanded';
import Store from 'store/store';
import Link from 'components/bolt/link/link';
import HTML from 'components/core/html/html';
import { joinClasses, sortObjectByOrder } from 'utils/utils';
import { getRelativePageUrl } from 'utils/bolt/index';
import { fade } from 'utils/bolt/transitions';
import SearchField from 'components/bolt/header/searchField';
import s from 'components/bolt/curzonHeader/curzonHeader.sss';

export default class CurzonHeader extends Component {
	constructor(props) {
		super(props);

		this.renderLink = this.renderLink.bind(this);
		this.onLogoClick = this.onLogoClick.bind(this);
		this.toggleSearch = this.toggleSearch.bind(this);
		this.onPageChange = this.onPageChange.bind(this);

		Store.on('SET_ACTIVE_PAGE', this.onPageChange);
	}

	toggleSearch() {
		if (!this.props?.searchData?.showSearchField) {
			Store.emit('CUSTOM_EVENT', {
				category: 'header',
				action: 'search-click',
				label: '-'
			});
		}
		Store.emit('TOGGLE_SEARCH_FIELD', (!this.props?.searchData?.showSearchField));
	}

	toggleNavOpen() {
		if (Store.get().header?.open) {
			Store.emit('CLOSE_NAV_MENU');
		} else {
			Store.emit('OPEN_NAV_MENU');
		}
	}

	onLogoClick() {
		const homePage = Object.values(this.props.appData.pages).find(page => page.path === '/' && page.base === 'bolt').id;
		Store.emit('SET_ACTIVE_PAGE', homePage);
	}

	onPageChange(page, doNotCollapseSearch) {
		if (page !== 'search' && this.props?.searchData?.showSearchField && !doNotCollapseSearch) {
			this.toggleSearch(false);
		}
	}

	renderLink(element) {
		const page = Object.values(this.props.appData.pages).find(page => page.id === element.path)?.id;
		const isInternalLink = !!page || element.path.startsWith('@');
		const activePage = this.props.activePage || 'boltHome';
		const active = activePage === element.path;
		const copy = this.props.appData?.copy.baseCopy;

		let attributes = {};
		const content = copy[element.name] || element.name;

		if (!isInternalLink) {
			attributes.href = element.path;
			attributes.target = element.sameWindow ? '_self' : '_blank';
			attributes.rel = 'noopener noreferrer';
		} else {
			attributes.href = getRelativePageUrl(element.path, '') || '#';
			attributes.onClick = element.onClick || (async (e) => {
				e.preventDefault();
				Store.emit('CUSTOM_EVENT', {
					category: 'header',
					action: 'nav-link-click',
					label: content
				});
				await fade(document.getElementById('mainScroll'), 'out', 500);
				Store.emit('CLOSE_AND_NAVIGATE', page);
				fade(document.getElementById('mainScroll'), 'in', 700);
			});
		}

		return (
			<Link
				key={element.name}
				class={joinClasses(s.link, active && s.active)}
				ariaLabel={element.name}
				{...attributes}
			>
				<HTML class={s.content} content={content} markdown />
			</Link>
		);
	}

	renderBurger() {
		const navOpen = Store.get().header?.open;
		const copy = this.props.appData.copy.accessibilityCopy;

		let burgerMenuAriaLabel = copy[navOpen ? '$CLOSE_NAV_ARIA' : '$OPEN_NAV_ARIA'];

		return (
			<div
				class={joinClasses(s.burger, navOpen && s.open)}
				onClick={this.toggleNavOpen}
				role="button"
				ariaLabel={burgerMenuAriaLabel}
			>
				<div class={s.line} />
				<div class={s.line} />
			</div>
		);
	}

	renderNav(data) {
		const links = sortObjectByOrder(data);

		return (
			<nav class={s.nav}>
				<li class={s.list}>
					{links.map(this.renderLink)}
				</li>
			</nav>
		);
	}

	renderSearchField() {

		return (
			<SearchField
				searchData={this.props.searchData || {}}
				isDesktopSearch={this.props?.client?.isDesktopSize}
			/>
		);
	}

	render(props) {
		const { appData, data, activePage, client, searchData = {} } = props;
		const { logo, nav } = data;
		const { src, altText, text } = logo;
		const navOpen = Store.get().header?.open;
		const isDesktopSize = client?.isDesktopSize && (client?.dimensions.height >= 467);
		const logoAriaLabel = appData.copy.baseCopy.$HOME;

		return (
			<header class={s.wrapper} id="header">
				<div class={s.container}>
					{!isDesktopSize && this.renderBurger()}
					<div class={s.logo} onClick={this.onLogoClick} role="button" ariaLabel={logoAriaLabel}>
						<img src={src} alt={altText} class={s.image} />
						<div class={s.text}>{text}</div>
					</div>
					{!isDesktopSize && (
						<HeaderExpanded
							appData={appData}
							activePage={activePage}
							headerData={data}
							navOpen={navOpen}
							client={client}
							key="expand"
						/>
					)}
					{isDesktopSize && this.renderNav(nav)}
					<button class={s.search} onClick={this.toggleSearch}><Search /></button>
				</div>
				{this.renderSearchField()}
			</header>
		);
	}
}